import * as yup from 'yup';

export const initialValues = {
  sku: '',
  washHub: '',
  quantity: '',
};

export const validationSchema = yup.object().shape({
  sku: yup.string().required('SKU is required'),
  washHub: yup.string(),
  quantity: yup.string().required('Quantity is required'),
});
